/* Collection grid progressive enhancement. The server-rendered next link
   remains fully usable when this script is unavailable. */
(function () {
  function fetchWithTimeout(url, options, timeout) {
    var controller = new AbortController();
    var timer = window.setTimeout(function () { controller.abort(); }, timeout || 12000);
    return fetch(url, Object.assign({}, options, { signal: controller.signal }))
      .finally(function () { window.clearTimeout(timer); });
  }

  function track(name, properties) {
    if (window.KPTheme && typeof window.KPTheme.track === 'function') {
      window.KPTheme.track(name, properties || {});
    }
  }

  function initCollectionGrid(root) {
    if (!root || root.dataset.collectionGridInitialized === 'true') return;
    root.dataset.collectionGridInitialized = 'true';

    var grid = root.querySelector('[data-collection-products]');
    var pagination = root.querySelector('[data-collection-pagination]');
    var status = root.querySelector('[data-collection-status]');
    if (!grid) return;

    function announce(message, tone) {
      if (!status) return;
      status.textContent = message || '';
      status.hidden = !message;
      status.dataset.tone = tone || 'info';
    }

    function jumpToGrid() {
      var header = document.querySelector('.header');
      var offset = header ? header.offsetHeight + 16 : 100;
      var top = grid.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo(0, top);
    }

    var params = new URLSearchParams(window.location.search);
    var filteredEntry = false;
    params.forEach(function (_, key) {
      if (key.indexOf('filter.') === 0 || key === 'sort_by') filteredEntry = true;
    });
    if (filteredEntry) {
      if (document.readyState === 'complete') jumpToGrid();
      else window.addEventListener('load', jumpToGrid, { once: true });
    }

    root.addEventListener('click', function (event) {
      var link = event.target.closest('[data-collection-next]');
      if (!link || !root.contains(link)) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      event.preventDefault();
      if (link.getAttribute('aria-busy') === 'true') return;

      var originalText = link.textContent;
      var pageUrl = new URL(link.href, window.location.href);
      var requestUrl = new URL(pageUrl);
      requestUrl.searchParams.set('section_id', root.dataset.sectionId);
      link.setAttribute('aria-busy', 'true');
      link.setAttribute('aria-disabled', 'true');
      link.textContent = link.dataset.loadingText || 'Loading…';
      announce('');
      track('collection_load_more_attempt', {
        page: Number(pageUrl.searchParams.get('page') || 0)
      });

      fetchWithTimeout(requestUrl.toString(), { headers: { Accept: 'text/html' } }, 12000)
        .then(function (response) {
          if (!response.ok) throw new Error('Collection page request failed');
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nextRoot = doc.querySelector('[data-collection-section="' + root.dataset.sectionId + '"]');
          var nextGrid = nextRoot && nextRoot.querySelector('[data-collection-products]');
          if (!nextGrid) throw new Error('Collection grid missing from response');

          var newItems = Array.from(nextGrid.children);
          newItems.forEach(function (item) { grid.appendChild(item); });

          var nextPagination = nextRoot.querySelector('[data-collection-pagination]');
          if (pagination && nextPagination) {
            var nextCount = nextPagination.querySelector('.coll-count');
            var count = pagination.querySelector('.coll-count');
            var nextBar = nextPagination.querySelector('.coll-progress i');
            var bar = pagination.querySelector('.coll-progress i');
            if (count && nextCount) count.textContent = nextCount.textContent;
            if (bar && nextBar) bar.style.width = nextBar.style.width;
          }

          var nextLink = nextRoot.querySelector('[data-collection-next]');
          if (nextLink) {
            link.href = new URL(nextLink.getAttribute('href'), pageUrl).toString();
            link.textContent = originalText;
            link.removeAttribute('aria-busy');
            link.removeAttribute('aria-disabled');
          } else {
            link.remove();
          }

          if (newItems.length) {
            var firstNewItem = newItems[0];
            firstNewItem.setAttribute('tabindex', '-1');
            firstNewItem.focus({ preventScroll: true });
            announce(newItems.length + ' more products loaded.');
          }

          window.history.pushState({ collectionPage: pageUrl.toString() }, '', pageUrl);
          track('collection_load_more_success', {
            page: Number(pageUrl.searchParams.get('page') || 0),
            item_count: newItems.length
          });
        })
        .catch(function () {
          link.textContent = originalText;
          link.removeAttribute('aria-busy');
          link.removeAttribute('aria-disabled');
          announce(link.dataset.errorText || 'Products could not be loaded. Please try again.', 'error');
          track('collection_load_more_failure', {
            page: Number(pageUrl.searchParams.get('page') || 0)
          });
        });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-collection-section]').forEach(initCollectionGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); }, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  window.addEventListener('popstate', function () {
    if (window.__kpMobileSearchPop) return;
    if (document.body.classList.contains('kp-search-open')) return;
    window.location.reload();
  });
})();
